export const LOCATION_TO_BREAD_CRUMB = {
  dashboard: ["Dashboard"],
  customers: ["Management", ">", "Customers"],
  projects: ["Management", ">", "Projects"],
  buildings: ["Management", ">", "Buildings"],
  devices: ["Management", ">", "Devices"],
  floors: ["Management", ">", "Floors"],
  "device-groups": ["Device Management", ">", "Device Groups"],
  "devices-prediction": ["Device Management", ">", "Device Prediction"],
  campaigns: ["Campaigns"],
  important: ["Important"],
  "important-list": ["Important", ">", "List"],
  "important-blocks": ["Important", ">", "Blocks"],
  "campaigns-list": ["Campaigns", ">", "List"],
  "campaign-blocks": ["Campaigns", ">", "Blocks"],
  medias: ["Medias"],
  "medias-list": ["Medias", ">", "List"],
  reports: ["Reports"],
  "action-logs": ["Reports", ">", "Action logs"],
  "media-logs": ["Reports", ">", "Media logs"],
  screenshot: ["Reports", ">", "Screenshot"],
  roles: ["Users Managements", ">", "Roles"],
  users: ["Users Managements", ">", "Users"],
};
